export default __webpack_public_path__ + "static/media/Hercampuri.be53bcad.jpeg";